module.exports = __webpack_public_path__ + "static/media/utensil-knife.e1b54e21.svg";